// import * as React from "react"
// import { useState, useEffect } from "react";
// import {
//     useNotify,
//     Button,
// } from "react-admin";
// import {
//     Box,
//     Card,
//     Typography,
//     Paper,
//     CircularProgress,
//     Alert,
//     useTheme,
//     alpha,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Tooltip,
//     TableContainer,
//     Table,
//     TableHead,
//     TableRow,
//     TableCell,
//     TableBody,
//     Grid,
//     CardContent,
//     Stack,
//     TablePagination,
// } from "@mui/material";

// import {
//     VolunteerActivism as DonateIcon,
//     RequestQuote as NeedIcon,
//     Handshake as MatchIcon,
//     CheckCircle as CompletedIcon,
//     PendingActions as PendingIcon,
//     Category as CategoryIcon,
//     Link as LinkIcon,
//     LocalOffer as OfferIcon,
// } from "@mui/icons-material";
// import { TextField as MuiTextField } from "@mui/material";
// import AssignDeliveryCompanyModal from "./AssignDeliveryCompanyModal";

// const token = JSON.parse(localStorage.getItem("token"));

// // Type Chip Component - Generic for both offers and services
// const TypeChip = ({ type, isService = false }) => {
//     const theme = useTheme();
//     const isDonation = isService ? type === 'donate' : type === 'donate';

//     return (
//         <Box
//             sx={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 gap: 0.5,
//                 px: 1.5,
//                 py: 0.5,
//                 borderRadius: '12px',
//                 backgroundColor: isDonation
//                     ? alpha(theme.palette.success.main, 0.1)
//                     : alpha(theme.palette.warning.main, 0.1),
//                 color: isDonation
//                     ? theme.palette.success.dark
//                     : theme.palette.warning.dark,
//                 fontWeight: 500,
//                 fontSize: '0.875rem',
//             }}
//         >
//             {isDonation ? <DonateIcon fontSize="small" /> : <NeedIcon fontSize="small" />}
//             <span>{isDonation ? 'Donation' : 'Need'}</span>
//         </Box>
//     );
// };

// // Status Chip Component
// const StatusChip = ({ status }) => {
//     const theme = useTheme();
//     const statusColors = {
//         active: theme.palette.success.main,
//         inactive: theme.palette.grey[500],
//         sold: theme.palette.info.main,
//         in_progress: theme.palette.warning.main,
//         donated: theme.palette.success.dark,
//     };

//     const statusIcons = {
//         active: <PendingIcon fontSize="small" />,
//         inactive: <PendingIcon fontSize="small" />,
//         sold: <CompletedIcon fontSize="small" />,
//         in_progress: <PendingIcon fontSize="small" />,
//         donated: <CompletedIcon fontSize="small" />,
//     };

//     const statusText = {
//         active: 'Active',
//         inactive: 'Inactive',
//         sold: 'Sold',
//         in_progress: 'In Progress',
//         donated: 'Donated',
//     };

//     return (
//         <Box
//             sx={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 gap: 0.5,
//                 px: 1.5,
//                 py: 0.5,
//                 borderRadius: '12px',
//                 backgroundColor: alpha(statusColors[status] || theme.palette.grey[500], 0.1),
//                 color: statusColors[status] || theme.palette.grey[700],
//                 fontWeight: 500,
//                 fontSize: '0.875rem',
//             }}
//         >
//             {statusIcons[status] || <PendingIcon fontSize="small" />}
//             {/* <span>{status?.charAt(0).toUpperCase() + status?.slice(1)}</span> */}
//             <span>{
//                 (statusText[status] || (status ? status.charAt(0).toUpperCase() + status.slice(1) : ''))
//             }</span>
//         </Box>
//     );
// };

// // Update the existing GenericTable component in InKindBaseReport.jsx
// const GenericTable = ({
//     data,
//     title,
//     onMarkAsDonated,
//     onAssignDelivery, // Add this prop
//     isService = false,
//     resourceName = 'admin/in-kind-offers',
//     showAssignButton = false, // Add this prop to control visibility
//     canSeeActionButtons = true,
//     page,
//     rowsPerPage,
//     total,
//     onPageChange,
//     onRowsPerPageChange,
// }) => {
//     const theme = useTheme();
//     const notify = useNotify();
//     const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//     const [selectedOffer, setSelectedOffer] = useState(null);
//     const [processing, setProcessing] = useState(false);
//     const [assignDeliveryOpen, setAssignDeliveryOpen] = useState(false); // Add state for assignment modal

//     const handleMarkAsDonatedClick = (offer) => {
//         setSelectedOffer(offer);
//         setConfirmDialogOpen(true);
//     };

//     const handleAssignDeliveryClick = (offer) => {
//         setSelectedOffer(offer);
//         setAssignDeliveryOpen(true);
//     };

//     const handleConfirmMarkAsDonated = async () => {
//         if (!selectedOffer) return;

//         try {
//             setProcessing(true);
//             await onMarkAsDonated(selectedOffer.id);
//             setConfirmDialogOpen(false);
//             setSelectedOffer(null);
//         } catch (error) {
//             console.error('Error marking as donated:', error);
//             notify('Error marking as donated', { type: 'error' });
//         } finally {
//             setProcessing(false);
//         }
//     };

//     if (!data || data.length === 0) {
//         return (
//             <Alert severity="info" sx={{ my: 2 }}>
//                 No {title.toLowerCase()} found.
//             </Alert>
//         );
//     }

//     const getTypeField = (record) => {
//         return isService ? record.service_type : record.offer_type;
//     };

//     const getDescription = (record) => {
//         if (isService) {
//             return record.description || 'Service';
//         }
//         return record.offer || 'Item';
//     };

//     const getCategory = (record) => {
//         if (isService) {
//             return record.service?.name || 'Service Type';
//         }
//         return record.subCategory?.name || 'Category';
//     };

//     const getQuantity = (record) => {
//         if (isService) {
//             return record.donation_capacity || record.quantity || '';
//         }
//         return `${record.quantity || ''} ${record._unit?.name || ''}`.trim();
//     };

//     return (
//         <>
//             <TableContainer component={Paper}>
//                 <Table>
//                     <TableHead>
//                         <TableRow>
//                             <TableCell>ID</TableCell>
//                             <TableCell>{isService ? 'Service' : 'Item'}</TableCell>
//                             <TableCell>{isService ? 'Service Type' : 'Category'}</TableCell>
//                             <TableCell>{isService ? 'Capacity' : 'Quantity'}</TableCell>
//                             <TableCell>Unit</TableCell>
//                             <TableCell>State</TableCell>
//                             <TableCell>User</TableCell>
//                             <TableCell>Date</TableCell>
//                             <TableCell>Type</TableCell>
//                             <TableCell>Status</TableCell>
//                             {canSeeActionButtons && <TableCell>Actions</TableCell>}
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {data.map((record) => {
//                             const isActive = record.status === 'active';
//                             const isInProgress = record.status === 'in_progress';
//                             const isDonation = getTypeField(record) === 'donate';
//                             // const isNeed = getTypeField(record) === 'need';
//                             const typeField = getTypeField(record);
//                             const isNeed =
//                                 (isService && String(typeField).toLowerCase() === 'need') ||
//                                 (!isService && typeField === 'need');
//                             console.log('Is Service:', isService, 'Status', record.status, 'Record Type:', typeField, 'isNeed:', isNeed);

//                             const canMarkAsDonated = isActive || isInProgress && (isDonation || isNeed);
//                             const canAssignDelivery = isActive && isNeed && showAssignButton; // Only show for active needs

//                             return (
//                                 <TableRow key={record.id} hover>
//                                     <TableCell>{record.id}</TableCell>
//                                     <TableCell>{getDescription(record)}</TableCell>
//                                     <TableCell>{getCategory(record)}</TableCell>
//                                     <TableCell>{getQuantity(record)}</TableCell>
//                                     <TableCell>{record._unit?.name}</TableCell>
//                                     <TableCell>{record._state?.name}</TableCell>
//                                     <TableCell>{record.user?.name}</TableCell>
//                                     <TableCell>
//                                         {new Date(record.created_at).toLocaleDateString()}
//                                     </TableCell>
//                                     <TableCell>
//                                         <TypeChip type={getTypeField(record)} isService={isService} />
//                                     </TableCell>
//                                     <TableCell>
//                                         <StatusChip status={record.status} />
//                                     </TableCell>
//                                     <TableCell>
//                                         <Box display="flex" gap={1}>
//                                             {/* Assign Delivery Button - Only for needs */}
//                                             {canAssignDelivery && (
//                                                 <Tooltip title="Assign delivery company">
//                                                     <Button
//                                                         size="small"
//                                                         variant="contained"
//                                                         // startIcon={<ShippingIcon />}
//                                                         onClick={() => handleAssignDeliveryClick(record)}
//                                                         disabled={!canAssignDelivery}
//                                                         color="primary"
//                                                         sx={{
//                                                             minWidth: 120,

//                                                             backgroundColor: canAssignDelivery
//                                                                 ? theme.palette.primary.main
//                                                                 : theme.palette.grey[400],
//                                                             '&:hover': {
//                                                                 backgroundColor: canAssignDelivery
//                                                                     ? theme.palette.primary.dark
//                                                                     : theme.palette.grey[400],
//                                                             }
//                                                         }}
//                                                     >
//                                                         Assign Delivery
//                                                     </Button>
//                                                 </Tooltip>
//                                             )}

//                                             {/* Mark as Donated Button */}
//                                             {canSeeActionButtons && (
//                                                 <Tooltip title={canMarkAsDonated ? "Mark as donated/completed" :
//                                                     isDonation ? "Already completed" :
//                                                         "Already fulfilled"}>
//                                                     <span>
//                                                         <Button
//                                                             size="small"
//                                                             variant="contained"
//                                                             startIcon={<CompletedIcon />}
//                                                             onClick={() => handleMarkAsDonatedClick(record)}
//                                                             disabled={!canMarkAsDonated}
//                                                             color="success"
//                                                             sx={{
//                                                                 minWidth: 120,
//                                                                 backgroundColor: canMarkAsDonated
//                                                                     ? theme.palette.success.main
//                                                                     : theme.palette.grey[400],
//                                                                 '&:hover': {
//                                                                     backgroundColor: canMarkAsDonated
//                                                                         ? theme.palette.success.dark
//                                                                         : theme.palette.grey[400],
//                                                                 }
//                                                             }}
//                                                         >
//                                                             Mark as Donated
//                                                         </Button>
//                                                     </span>
//                                                 </Tooltip>
//                                             )}
//                                         </Box>
//                                     </TableCell>
//                                 </TableRow>
//                             );
//                         })}
//                     </TableBody>
//                 </Table>
//             </TableContainer>

//             <TablePagination
//                 component="div"
//                 count={total}
//                 page={page}
//                 onPageChange={(e, newPage) => onPageChange(newPage)}
//                 rowsPerPage={rowsPerPage}
//                 onRowsPerPageChange={(e) =>
//                     onRowsPerPageChange(parseInt(e.target.value, 10))
//                 }
//             />
//             {/* Confirmation Dialog for Mark as Donated */}
//             <Dialog
//                 open={confirmDialogOpen}
//                 onClose={() => !processing && setConfirmDialogOpen(false)}
//                 maxWidth="sm"
//                 fullWidth
//             >
//                 <DialogTitle>
//                     <Box display="flex" alignItems="center" gap={1}>
//                         <CompletedIcon color="success" />
//                         <Typography variant="h6">
//                             Mark as Donated/Completed
//                         </Typography>
//                     </Box>
//                 </DialogTitle>
//                 <DialogContent>
//                     {selectedOffer && (
//                         <Box>
//                             <Typography variant="body1" sx={{ mb: 2 }}>
//                                 Are you sure you want to mark this item as donated/completed?
//                             </Typography>
//                             <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
//                                 <Typography variant="subtitle2" gutterBottom>
//                                     Item Details
//                                 </Typography>
//                                 <Typography variant="body2">
//                                     <strong>ID:</strong> {selectedOffer.id}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                     <strong>Item:</strong> {getDescription(selectedOffer)}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                     <strong>Type:</strong> {
//                                         getTypeField(selectedOffer) === 'donate' ? 'Donation' : 'Need'
//                                     }
//                                 </Typography>
//                                 <Typography variant="body2">
//                                     <strong>Quantity:</strong> {getQuantity(selectedOffer)}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                     <strong>User:</strong> {selectedOffer.user?.name}
//                                 </Typography>
//                                 <Typography variant="body2">
//                                     <strong>Status:</strong> {selectedOffer.status}
//                                 </Typography>
//                             </Card>
//                             <Alert severity="info" sx={{ mt: 2 }}>
//                                 This will change the status to "donated" and remove it from active listings.
//                                 {getTypeField(selectedOffer) === 'need' && ' (For needs, status will be changed to "donated" as well)'}
//                             </Alert>
//                         </Box>
//                     )}
//                 </DialogContent>
//                 <DialogActions>
//                     <Button
//                         onClick={() => setConfirmDialogOpen(false)}
//                         disabled={processing}
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         onClick={handleConfirmMarkAsDonated}
//                         color="success"
//                         variant="contained"
//                         disabled={processing}
//                         startIcon={processing ? <CircularProgress size={20} /> : <CompletedIcon />}
//                     >
//                         {processing ? 'Processing...' : 'Mark as Donated'}
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             {/* Assign Delivery Modal */}
//             {assignDeliveryOpen && selectedOffer && (
//                 <AssignDeliveryCompanyModal
//                     open={assignDeliveryOpen}
//                     onClose={(success) => {
//                         setAssignDeliveryOpen(false);
//                         setSelectedOffer(null);
//                         if (success && onAssignDelivery) {
//                             onAssignDelivery();
//                         }
//                     }}
//                     selectedNeed={selectedOffer}
//                     type={isService ? 'SERVICE' : 'CROP'}
//                     token={token}
//                 />
//             )}
//         </>
//     );
// };

// // Generic Match Dialog Component
// const GenericMatchDialog = ({
//     open,
//     onClose,
//     donation,
//     need,
//     onMatch,
//     isService = false
// }) => {
//     const theme = useTheme();
//     const [notes, setNotes] = useState('');

//     const handleMatch = () => {
//         onMatch(donation.id, need.id, notes);
//         onClose();
//     };

//     const getDescription = (item) => {
//         if (isService) {
//             return item?.description || 'Service description';
//         }
//         return item?.offer || 'Item';
//     };

//     const getCategory = (item) => {
//         if (isService) {
//             return item?.service?.name || 'Service type';
//         }
//         return item?.subCategory?.name || 'Category';
//     };

//     const getQuantity = (item) => {
//         if (isService) {
//             return item?.donation_capacity || item?.quantity || 'Capacity not specified';
//         }
//         return `${item?.quantity || ''} ${item?._unit?.name || ''}`.trim();
//     };

//     return (
//         <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//             <DialogTitle>
//                 <Box display="flex" alignItems="center" gap={1}>
//                     <MatchIcon color="primary" />
//                     <Typography variant="h6">
//                         Match {isService ? 'Service ' : ''}Donation with Need
//                     </Typography>
//                 </Box>
//             </DialogTitle>
//             <DialogContent>
//                 <Grid container spacing={3} sx={{ mt: 1 }}>
//                     <Grid item xs={12} md={6}>
//                         <Card variant="outlined">
//                             <CardContent>
//                                 <Typography variant="subtitle1" gutterBottom fontWeight="bold" color="success.main">
//                                     {isService ? 'Service ' : ''}Donation
//                                 </Typography>
//                                 <Stack spacing={1}>
//                                     <Typography variant="body2">
//                                         <strong>{isService ? 'Service' : 'Item'}:</strong> {getDescription(donation)}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>{isService ? 'Service Type' : 'Category'}:</strong> {getCategory(donation)}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>{isService ? 'Capacity' : 'Quantity'}:</strong> {getQuantity(donation)}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>Location:</strong> {donation?._state?.name}, {donation?._city?.name || 'N/A'}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>Donor:</strong> {donation?.user?.name}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>Phone:</strong> {donation?.user?.phonenumber}
//                                     </Typography>
//                                 </Stack>
//                             </CardContent>
//                         </Card>
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                         <Card variant="outlined">
//                             <CardContent>
//                                 <Typography variant="subtitle1" gutterBottom fontWeight="bold" color="warning.main">
//                                     {isService ? 'Service ' : ''}Need
//                                 </Typography>
//                                 <Stack spacing={1}>
//                                     <Typography variant="body2">
//                                         <strong>{isService ? 'Service' : 'Item'}:</strong> {getDescription(need)}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>{isService ? 'Service Type' : 'Category'}:</strong> {getCategory(need)}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>{isService ? 'Required Capacity' : 'Quantity Needed'}:</strong> {getQuantity(need)}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>Location:</strong> {need?._state?.name}, {need?._city?.name || 'N/A'}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>Requester:</strong> {need?.user?.name}
//                                     </Typography>
//                                     <Typography variant="body2">
//                                         <strong>Phone:</strong> {need?.user?.phonenumber}
//                                     </Typography>
//                                 </Stack>
//                             </CardContent>
//                         </Card>
//                     </Grid>

//                     <Grid item xs={12}>
//                         <MuiTextField
//                             fullWidth
//                             multiline
//                             rows={3}
//                             label="Matching Notes"
//                             value={notes}
//                             onChange={(e) => setNotes(e.target.value)}
//                             placeholder="Add any notes about this match..."
//                         />
//                     </Grid>
//                 </Grid>
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={onClose}>Cancel</Button>
//                 <Button onClick={handleMatch} color="primary" variant="contained" startIcon={<LinkIcon />}>
//                     Create Match
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// export default GenericTable;
import * as React from "react"
import { useState, useEffect } from "react";
import {
    useNotify,
    Button,
} from "react-admin";
import {
    Box,
    Card,
    Typography,
    Paper,
    CircularProgress,
    Alert,
    useTheme,
    alpha,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tooltip,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Grid,
    CardContent,
    Stack,
    TablePagination,
    IconButton,
} from "@mui/material";

import {
    VolunteerActivism as DonateIcon,
    RequestQuote as NeedIcon,
    Handshake as MatchIcon,
    CheckCircle as CompletedIcon,
    PendingActions as PendingIcon,
    Category as CategoryIcon,
    Link as LinkIcon,
    LocalOffer as OfferIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
} from "@mui/icons-material";
import { TextField as MuiTextField } from "@mui/material";
import AssignDeliveryCompanyModal from "./AssignDeliveryCompanyModal";

const token = JSON.parse(localStorage.getItem("token"));

// Type Chip Component - Generic for both offers and services
const TypeChip = ({ type, isService = false }) => {
    const theme = useTheme();
    const isDonation = isService ? type === 'donate' : type === 'donate';

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                px: 1.5,
                py: 0.5,
                borderRadius: '12px',
                backgroundColor: isDonation
                    ? alpha(theme.palette.success.main, 0.1)
                    : alpha(theme.palette.warning.main, 0.1),
                color: isDonation
                    ? theme.palette.success.dark
                    : theme.palette.warning.dark,
                fontWeight: 500,
                fontSize: '0.875rem',
            }}
        >
            {isDonation ? <DonateIcon fontSize="small" /> : <NeedIcon fontSize="small" />}
            <span>{isDonation ? 'Donation' : 'Need'}</span>
        </Box>
    );
};

// Status Chip Component
const StatusChip = ({ status }) => {
    const theme = useTheme();
    const statusColors = {
        active: theme.palette.success.main,
        inactive: theme.palette.grey[500],
        sold: theme.palette.info.main,
        in_progress: theme.palette.warning.main,
        donated: theme.palette.success.dark,
    };

    const statusIcons = {
        active: <PendingIcon fontSize="small" />,
        inactive: <PendingIcon fontSize="small" />,
        sold: <CompletedIcon fontSize="small" />,
        in_progress: <PendingIcon fontSize="small" />,
        donated: <CompletedIcon fontSize="small" />,
    };

    const statusText = {
        active: 'Active',
        inactive: 'Inactive',
        sold: 'Sold',
        in_progress: 'In Progress',
        donated: 'Donated',
    };

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                px: 1.5,
                py: 0.5,
                borderRadius: '12px',
                backgroundColor: alpha(statusColors[status] || theme.palette.grey[500], 0.1),
                color: statusColors[status] || theme.palette.grey[700],
                fontWeight: 500,
                fontSize: '0.875rem',
            }}
        >
            {statusIcons[status] || <PendingIcon fontSize="small" />}
            <span>{
                (statusText[status] || (status ? status.charAt(0).toUpperCase() + status.slice(1) : ''))
            }</span>
        </Box>
    );
};

// Update the existing GenericTable component in InKindBaseReport.jsx
const GenericTable = ({
    data,
    title,
    onMarkAsDonated,
    onAssignDelivery,
    isService = false,
    resourceName = 'admin/in-kind-offers',
    showAssignButton = false,
    canSeeActionButtons = true,
    page,
    rowsPerPage,
    total,
    onPageChange,
    onRowsPerPageChange,
    // New props
    onEdit,
    onDelete,
    canEdit = false,
    canDelete = false,
}) => {
    const theme = useTheme();
    const notify = useNotify();
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [assignDeliveryOpen, setAssignDeliveryOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteProcessing, setDeleteProcessing] = useState(false);

    const handleMarkAsDonatedClick = (offer) => {
        setSelectedOffer(offer);
        setConfirmDialogOpen(true);
    };

    const handleAssignDeliveryClick = (offer) => {
        setSelectedOffer(offer);
        setAssignDeliveryOpen(true);
    };

    const handleEditClick = (offer) => {
        if (onEdit) {
            onEdit(offer.id);
        }
    };

    const handleDeleteClick = (offer) => {
        setSelectedOffer(offer);
        setDeleteDialogOpen(true);
    };

    const handleConfirmDelete = async () => {
        if (!selectedOffer || !onDelete) return;

        try {
            setDeleteProcessing(true);
            await onDelete(selectedOffer.id);
            setDeleteDialogOpen(false);
            setSelectedOffer(null);
        } catch (error) {
            console.error('Delete error:', error);
            notify('Error deleting item', { type: 'error' });
        } finally {
            setDeleteProcessing(false);
        }
    };

    const handleConfirmMarkAsDonated = async () => {
        if (!selectedOffer) return;

        try {
            setProcessing(true);
            await onMarkAsDonated(selectedOffer.id);
            setConfirmDialogOpen(false);
            setSelectedOffer(null);
        } catch (error) {
            console.error('Error marking as donated:', error);
            notify('Error marking as donated', { type: 'error' });
        } finally {
            setProcessing(false);
        }
    };

    if (!data || data.length === 0) {
        return (
            <Alert severity="info" sx={{ my: 2 }}>
                No {title.toLowerCase()} found.
            </Alert>
        );
    }

    const getTypeField = (record) => {
        return isService ? record.service_type : record.offer_type;
    };

    const getDescription = (record) => {
        if (isService) {
            return record.description || 'Service';
        }
        return record.offer || 'Item';
    };

    const getCategory = (record) => {
        if (isService) {
            return record.service?.name || 'Service Type';
        }
        return record.subCategory?.name || 'Category';
    };

    const getQuantity = (record) => {
        if (isService) {
            return record.donation_capacity || record.quantity || '';
        }
        return `${record.quantity || ''} ${record._unit?.name || ''}`.trim();
    };

    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>{isService ? 'Service' : 'Item'}</TableCell>
                            <TableCell>{isService ? 'Service Type' : 'Category'}</TableCell>
                            <TableCell>{isService ? 'Capacity' : 'Quantity'}</TableCell>
                            <TableCell>Unit</TableCell>
                            <TableCell>State</TableCell>
                            <TableCell>User</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Status</TableCell>
                            {(canSeeActionButtons || canEdit || canDelete) && <TableCell align="center">Actions</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((record) => {
                            const isActive = record.status === 'active';
                            const isInProgress = record.status === 'in_progress';
                            const isDonation = getTypeField(record) === 'donate';
                            const typeField = getTypeField(record);
                            const isNeed =
                                (isService && String(typeField).toLowerCase() === 'need') ||
                                (!isService && typeField === 'need');
                            console.log('Is Service:', isService, 'Status', record.status, 'Record Type:', typeField, 'isNeed:', isNeed);

                            const canMarkAsDonated = isActive || isInProgress && (isDonation || isNeed);
                            const canAssignDelivery = isActive && isNeed && showAssignButton;

                            return (
                                <TableRow key={record.id} hover>
                                    <TableCell>{record.id}</TableCell>
                                    <TableCell>{getDescription(record)}</TableCell>
                                    <TableCell>{getCategory(record)}</TableCell>
                                    <TableCell>{getQuantity(record)}</TableCell>
                                    <TableCell>{record._unit?.name}</TableCell>
                                    <TableCell>{record._state?.name}</TableCell>
                                    <TableCell>{record.user?.name}</TableCell>
                                    <TableCell>
                                        {new Date(record.created_at).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell>
                                        <TypeChip type={getTypeField(record)} isService={isService} />
                                    </TableCell>
                                    <TableCell>
                                        <StatusChip status={record.status} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Box display="flex" gap={1} justifyContent="center" flexWrap="wrap">
                                            {/* Edit Button */}
                                            {canEdit && onEdit && (
                                                <Tooltip title="Edit">
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => handleEditClick(record)}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {/* Delete Button */}
                                            {canDelete && onDelete && (
                                                <Tooltip title="Delete">
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => handleDeleteClick(record)}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {/* Assign Delivery Button - Only for needs */}
                                            {canAssignDelivery && (
                                                <Tooltip title="Assign delivery company">
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        onClick={() => handleAssignDeliveryClick(record)}
                                                        disabled={!canAssignDelivery}
                                                        color="primary"
                                                        sx={{
                                                            minWidth: 100,
                                                            backgroundColor: canAssignDelivery
                                                                ? theme.palette.primary.main
                                                                : theme.palette.grey[400],
                                                            '&:hover': {
                                                                backgroundColor: canAssignDelivery
                                                                    ? theme.palette.primary.dark
                                                                    : theme.palette.grey[400],
                                                            }
                                                        }}
                                                    >
                                                        Assign Delivery
                                                    </Button>
                                                </Tooltip>
                                            )}

                                            {/* Mark as Donated Button */}
                                            {canSeeActionButtons && (
                                                <Tooltip title={canMarkAsDonated ? "Mark as donated/completed" :
                                                    isDonation ? "Already completed" :
                                                        "Already fulfilled"}>
                                                    <span>
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            startIcon={<CompletedIcon />}
                                                            onClick={() => handleMarkAsDonatedClick(record)}
                                                            disabled={!canMarkAsDonated}
                                                            color="success"
                                                            sx={{
                                                                minWidth: 100,
                                                                backgroundColor: canMarkAsDonated
                                                                    ? theme.palette.success.main
                                                                    : theme.palette.grey[400],
                                                                '&:hover': {
                                                                    backgroundColor: canMarkAsDonated
                                                                        ? theme.palette.success.dark
                                                                        : theme.palette.grey[400],
                                                                }
                                                            }}
                                                        >
                                                            Mark Donated
                                                        </Button>
                                                    </span>
                                                </Tooltip>
                                            )}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                component="div"
                count={total}
                page={page}
                onPageChange={(e, newPage) => onPageChange(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) =>
                    onRowsPerPageChange(parseInt(e.target.value, 10))
                }
            />

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={deleteDialogOpen}
                onClose={() => !deleteProcessing && setDeleteDialogOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DeleteIcon color="error" />
                        <Typography variant="h6">
                            Confirm Delete
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {selectedOffer && (
                        <Box>
                            <Typography variant="body1" sx={{ mb: 2, color: 'error.main' }}>
                                Are you sure you want to delete this item? This action cannot be undone.
                            </Typography>
                            <Card variant="outlined" sx={{ p: 2, mb: 2, bgcolor: alpha(theme.palette.error.main, 0.05) }}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Item Details
                                </Typography>
                                <Typography variant="body2">
                                    <strong>ID:</strong> {selectedOffer.id}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Item:</strong> {getDescription(selectedOffer)}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Type:</strong> {
                                        getTypeField(selectedOffer) === 'donate' ? 'Donation' : 'Need'
                                    }
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Quantity:</strong> {getQuantity(selectedOffer)}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>User:</strong> {selectedOffer.user?.name}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Status:</strong> {selectedOffer.status}
                                </Typography>
                            </Card>
                            <Alert severity="warning">
                                Deleting this item will permanently remove it from the system.
                            </Alert>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setDeleteDialogOpen(false)}
                        disabled={deleteProcessing}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmDelete}
                        color="error"
                        variant="contained"
                        disabled={deleteProcessing}
                        startIcon={deleteProcessing ? <CircularProgress size={20} /> : <DeleteIcon />}
                    >
                        {deleteProcessing ? 'Deleting...' : 'Delete Permanently'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirmation Dialog for Mark as Donated */}
            <Dialog
                open={confirmDialogOpen}
                onClose={() => !processing && setConfirmDialogOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    <Box display="flex" alignItems="center" gap={1}>
                        <CompletedIcon color="success" />
                        <Typography variant="h6">
                            Mark as Donated/Completed
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {selectedOffer && (
                        <Box>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                Are you sure you want to mark this item as donated/completed?
                            </Typography>
                            <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
                                <Typography variant="subtitle2" gutterBottom>
                                    Item Details
                                </Typography>
                                <Typography variant="body2">
                                    <strong>ID:</strong> {selectedOffer.id}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Item:</strong> {getDescription(selectedOffer)}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Type:</strong> {
                                        getTypeField(selectedOffer) === 'donate' ? 'Donation' : 'Need'
                                    }
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Quantity:</strong> {getQuantity(selectedOffer)}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>User:</strong> {selectedOffer.user?.name}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Status:</strong> {selectedOffer.status}
                                </Typography>
                            </Card>
                            <Alert severity="info" sx={{ mt: 2 }}>
                                This will change the status to "donated" and remove it from active listings.
                                {getTypeField(selectedOffer) === 'need' && ' (For needs, status will be changed to "donated" as well)'}
                            </Alert>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setConfirmDialogOpen(false)}
                        disabled={processing}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmMarkAsDonated}
                        color="success"
                        variant="contained"
                        disabled={processing}
                        startIcon={processing ? <CircularProgress size={20} /> : <CompletedIcon />}
                    >
                        {processing ? 'Processing...' : 'Mark as Donated'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Assign Delivery Modal */}
            {assignDeliveryOpen && selectedOffer && (
                <AssignDeliveryCompanyModal
                    open={assignDeliveryOpen}
                    onClose={(success) => {
                        setAssignDeliveryOpen(false);
                        setSelectedOffer(null);
                        if (success && onAssignDelivery) {
                            onAssignDelivery();
                        }
                    }}
                    selectedNeed={selectedOffer}
                    type={isService ? 'SERVICE' : 'CROP'}
                    token={token}
                />
            )}
        </>
    );
};

// Generic Match Dialog Component
const GenericMatchDialog = ({
    open,
    onClose,
    donation,
    need,
    onMatch,
    isService = false
}) => {
    const theme = useTheme();
    const [notes, setNotes] = useState('');

    const handleMatch = () => {
        onMatch(donation.id, need.id, notes);
        onClose();
    };

    const getDescription = (item) => {
        if (isService) {
            return item?.description || 'Service description';
        }
        return item?.offer || 'Item';
    };

    const getCategory = (item) => {
        if (isService) {
            return item?.service?.name || 'Service type';
        }
        return item?.subCategory?.name || 'Category';
    };

    const getQuantity = (item) => {
        if (isService) {
            return item?.donation_capacity || item?.quantity || 'Capacity not specified';
        }
        return `${item?.quantity || ''} ${item?._unit?.name || ''}`.trim();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Box display="flex" alignItems="center" gap={1}>
                    <MatchIcon color="primary" />
                    <Typography variant="h6">
                        Match {isService ? 'Service ' : ''}Donation with Need
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={6}>
                        <Card variant="outlined">
                            <CardContent>
                                <Typography variant="subtitle1" gutterBottom fontWeight="bold" color="success.main">
                                    {isService ? 'Service ' : ''}Donation
                                </Typography>
                                <Stack spacing={1}>
                                    <Typography variant="body2">
                                        <strong>{isService ? 'Service' : 'Item'}:</strong> {getDescription(donation)}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>{isService ? 'Service Type' : 'Category'}:</strong> {getCategory(donation)}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>{isService ? 'Capacity' : 'Quantity'}:</strong> {getQuantity(donation)}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>Location:</strong> {donation?._state?.name}, {donation?._city?.name || 'N/A'}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>Donor:</strong> {donation?.user?.name}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>Phone:</strong> {donation?.user?.phonenumber}
                                    </Typography>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Card variant="outlined">
                            <CardContent>
                                <Typography variant="subtitle1" gutterBottom fontWeight="bold" color="warning.main">
                                    {isService ? 'Service ' : ''}Need
                                </Typography>
                                <Stack spacing={1}>
                                    <Typography variant="body2">
                                        <strong>{isService ? 'Service' : 'Item'}:</strong> {getDescription(need)}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>{isService ? 'Service Type' : 'Category'}:</strong> {getCategory(need)}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>{isService ? 'Required Capacity' : 'Quantity Needed'}:</strong> {getQuantity(need)}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>Location:</strong> {need?._state?.name}, {need?._city?.name || 'N/A'}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>Requester:</strong> {need?.user?.name}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>Phone:</strong> {need?.user?.phonenumber}
                                    </Typography>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12}>
                        <MuiTextField
                            fullWidth
                            multiline
                            rows={3}
                            label="Matching Notes"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="Add any notes about this match..."
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleMatch} color="primary" variant="contained" startIcon={<LinkIcon />}>
                    Create Match
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GenericTable;